var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_loading),expression:"show_loading"}],staticClass:"loading",on:{"touchmove":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"loading_spinner"},_vm._l((_vm.spinner),function(item,index){return _c('div',{key:index})}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-337b85c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/act/202010/unit_member/comp/Loading.vue
// module id = null
// module chunks = 